
import CustomImage from "components/common/CustomImage";
import TranslucencyMask from "components/common/TranslucencyMask";
import { useHttpUtil } from "context/HttpContext";
import { usePermissionContext } from "context/Permission";
import Stats from "libs/utils/stats";
import Tools from "libs/utils/Tools";
import { createContext, useContext, useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router";
import { useDetailContext } from "../editor/DetailContext";
import { ActionName, EventCallbackParamsType } from "../editor/MockupEditor";


interface MockupsObj {
  isMockups : boolean,
  mockupsDetail ?: MockupDetail,
  showLogin : () => void
}
export const MockupsContext = createContext<MockupsObj|null>(null);

export function useMockupsContext() : MockupsObj | null{
  return useContext(MockupsContext);
}

export default function MockupsContextProvider(props: {children: any, isMockupsSrc: boolean}) {
    const {children, isMockupsSrc} = props ;
    const httpUtil = useHttpUtil();
    const params = useParams() ;
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id') || params.id ;

    const detailContext  = useDetailContext();
    const permissionContext = usePermissionContext();

    const [ mockupsDetail, setMockupsDetail ] = useState<MockupDetail>();
    const [ isMockups, setIsMockups ] = useState<boolean>(isMockupsSrc);

    const [ isShowLogin, setIsShowLogin ] = useState<boolean>(false)

    useEffect(() => {
        isMockups && loadMockupDetail(id as string)
    }, [id, isMockups])

    useEffect(() => {
        if((localStorage.getItem('GUEST-MOCKUP-COUNT') || 0) >= 2){
            setMockupsDetail((detail) => {
                return {
                    ...detail,
                    isMockuped: true
                }
            })
        }
    }, [ ])

    const loadMockupDetail = async (id: string) => {
        const data = await httpUtil.post('/biz/product/mockup/detail', {
            id
        });
        const resultData = data.data;
        // 是否有项目,如果有表示用户已登录
        const project = resultData.project ;
        let isLogin = false;
        if(project){
            isLogin = true ;
            // setIsMockups(false);
            detailContext?.setProject(project);
        }

        setMockupsDetail((detail) => {
            return {
                ...detail,
                ...resultData.product ? 
                    {id, url: resultData.product.url, mockupData : resultData.product.mockupData ? JSON.parse(resultData.product.mockupData) : undefined} 
                    : { isImageLoaded : true, isMockuped: true},
                isLogin: isLogin,
            }
        })
    }

    useEffect(() => {
        if(mockupsDetail?.isEditorLoaded && !mockupsDetail?.isImageLoaded && !mockupsDetail.isMockuped && mockupsDetail.url){
            if(mockupsDetail.mockupData && mockupsDetail.mockupData.mockup){
                detailContext?.triggerEditorAction({
                    name: ActionName.LOADING_MOCUP_IMAGE,
                    params: {
                        url: mockupsDetail.url,
                        mockupUrl: mockupsDetail.mockupData.mockup
                    }
                })
            }else{
                detailContext?.triggerEditorAction({
                    name: ActionName.LOADING_IMAGE,
                    params: mockupsDetail.url
                })
            }
        }
    }, [ mockupsDetail ])

    useEffect(() => {  
        if(!isMockups) return ;
        disponseCallbackData();
    },[detailContext?.editorCallbackData, isMockups])

    const disponseCallbackData = async () => {
        const type = detailContext?.editorCallbackData?.type ;
        const data = detailContext?.editorCallbackData?.data ;
        switch(type){
            case EventCallbackParamsType.EDITOR_INIT_FINISHED: // 编辑器初始化完成
                setMockupsDetail((detail) => {
                    return {
                        ...detail,
                        isEditorLoaded: true
                    }
                })
                break;
            case EventCallbackParamsType.ADD_ELEMENT_SUC_CALLBACK: // 添加图像完成
                setMockupsDetail((detail) => {
                    return {
                        ...detail,
                        isImageLoaded: true
                    }
                })
                if(!mockupsDetail?.isMockuped){
                    if(mockupsDetail?.isLogin){
                        const resData = await httpUtil.post('/biz/func/mockup',{
                            projectId: detailContext?.project.projectId
                        })
                        if(!resData.errCode){
                            detailContext?.triggerEditorAction({
                                name: ActionName.MOCKUP,
                                params: `${data.uuid}`
                            })
            
                            permissionContext?.updator();
                        }
                    }else{ 
                        detailContext?.triggerEditorAction({
                            name: ActionName.MOCKUP,
                            params: `${data.uuid}`
                        })
                    }
                    Stats.google('Mockup');
                }
                break;
            case EventCallbackParamsType.MOCKUP_IMAGE_FINISH: // Mockup转换完成
                setMockupsDetail((detail) => {
                    return {
                        ...detail,
                        isMockuped: true
                    }
                })
                break;
        }
    }

    const showLogin = () => {
        setIsShowLogin(true);
    }

    const hideLogin = () => {
        setIsShowLogin(false);
    }

  return (
    <MockupsContext.Provider value={{
        isMockups,
        mockupsDetail,
        showLogin
    }}>
        {children}
        {
           isShowLogin &&
           <TranslucencyMask className="z-[10010]" closeHandler={() => {hideLogin()}}>
                <div className="absolute w-[400px] bg-[#FFFFFF] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] shadow-box rounded-[10px]">
                    <CustomImage src="/icon/icon-close.png" className="absolute right-[20px] top-[20px] w-[30px] cursor-pointer" 
                            onClick={hideLogin}/>
                    <div className="px-[40px] py-[50px] flex flex-col justify-center items-center">
                        <CustomImage src="/logo.png" className="w-[213px]" />
                        <p className="mt-[30px] text-[#000000] text-[28px] text-center">Sign up for <br/>free to use this feature</p>
                        <div className="mt-[130px] flex flex-col gap-[20px] w-full">
                            <a href={Tools.getLoginUrl()} className="text-center py-[10px] border border-[#000000] rounded-[10px] text-[18px] font-[500]">Sign In</a>
                            <a href={Tools.disponseUrl('/signup')} className="text-center py-[10px] bg-[#000000] text-[#FFFFFF] rounded-[10px] text-[18px] font-[500]">Sign Up</a>
                        </div>
                    </div>
                </div> 
           </TranslucencyMask>
        }
    </MockupsContext.Provider>
  )
}


export type MockupDetail = {
    id ?: string,
    url ?: string,
    mockupData ?: MockupData,
    isLogin ?: boolean,
    isEditorLoaded ?: boolean,
    isImageLoaded ?: boolean,
    isMockuped ?: boolean
}

type MockupData = {
    mockup : string
}